export const RULE_LIMIT = 5;



// WEBPACK FOOTER //
// ./src/constants/limits.js